import { FileViewerPreviewStyled } from './styles/FileViewerPreviewStyled'
import { useFileViewerContext } from '../../FileViewerContext'
import { FilePreview } from '@ui/blocks/FilePreview'

export interface IFileViewerPreviewProps {}

export const FileViewerPreview = () => {
  const { selectedFile, getFileData } = useFileViewerContext()

  const fileData = getFileData(selectedFile)

  return (
    <FileViewerPreviewStyled>
      <FilePreview
        src={fileData?.file}
        mimetype={fileData?.mimetype}
        filename={fileData?.name}
      />
    </FileViewerPreviewStyled>
  )
}
